import { render, staticRenderFns } from "./buildingTexts.vue?vue&type=template&id=179b3a68&"
import script from "./buildingTexts.vue?vue&type=script&lang=js&"
export * from "./buildingTexts.vue?vue&type=script&lang=js&"
import style0 from "./buildingTexts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports